export default (state, {payload}) => ({
  ...state,
  serviceConsumer: payload
});
